import axios from 'axios'
import services from '@/config/services'
import authHeader from '../auth/auth-header';
import Cookies from 'js-cookie';
import FileManager from '@/services/ask-file-manager/index.js'


export default class PraticheService{
    constructor(eventBus){
        this.eventBus = eventBus
        this.baseUrl = `${services.ask_pratiche.url}`
        this.baseUrlToken = `${services.ask_pratiche_token.url}`
        this.baseUrlApi = `${services.ask_pratiche_api.url}`
        this.baseUrlFlussi = `${services.ask_flussi_api.url}`
        this.baseUrlScraper = `${services.ask_pratiche_scraper.url}`
        this.baseAdminUrl = `${services.admin.url}`
        this.filemanager = new FileManager()
        axios.interceptors.request.use(
          (req) => {
            req.headers["Authorization"] = authHeader()
            req.headers["Params"] = Cookies.get('google_access_token') || Cookies.get('ask_access_token')
            // this.eventBus.emit('data-loading');
            return req
          }
        )
      }

  async getAllFatture(){
    let items = []
    const url = `${this.baseUrl}/get-fatture-all`

    try {
      let res =  await axios.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  
  async UploadZipMpsOrBPM(formData) {
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/UploadZipMpsOrBPM`;
    try {
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }


  async getPreviewData(params) {
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/GetPreviewData`;
    try {
      const response = await axios.get(url, { params });
      return response;
    } catch (error) {
      console.error('Error getting preview data:', error);
      throw error;
    }
  }


  async getRiepilogoGettoni(idAgente, mese) {
    let items = []
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/getRiepilogoGettoni`

    try {
      let res = await axios.get(url, {
        params: {
          id_agente: idAgente,
          mese: mese
        }
      })
      items = res.data.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }

  async processInvoices(invoices) {
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/ProcessInvoices`
    try {
      const response = await axios.post(url, { invoices })
      return response
    } catch (error) {
      console.error('Error processing invoices:', error)
      throw error
    }
  }


  async getAllFattureVendita(){
    let items = []
    const url = `${this.baseUrl}/get-fatture-vendita-all`

    try {
      let res =  await axios.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getFattureDetails(id){
    let items = []
    const url = `${this.baseUrl}/get-fatture-details/${id}`

    try {
      let res =  await axios.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getBilancioFattAcquisto(data_emissione, data_competenza, distributore){
    let items = []
    const url = `${this.baseUrl}/bilancio/fatture/acquisto/${data_emissione}/${data_competenza}/${distributore}`

    try {
      let res =  await axios.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getBilancioFattFornitori(data_emissione, data_competenza, fornitore){
    let items = []
    const url = `${this.baseUrl}/bilancio/fatture/fornitori/${data_emissione}/${data_competenza}/${fornitore}`

    try {
      let res =  await axios.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getDistributori(){
    let items = []
    const url = `${this.baseUrl}/distributori/fatture/acquisto`

    try {
      let res =  await axios.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getAllPun(){
    let items = []
    const url = `${this.baseUrl}/get-pun`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async editPun(value){
    const url = `${this.baseUrl}/edit-pun`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async createPun(value){
    const url = `${this.baseUrl}/create-pun`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deletePun(value){

    const url = `${this.baseUrl}/delete-pun`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deletePuns(value){
    const url = `${this.baseUrl}/delete-puns`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async getAllTariffe(){
    let items = {}
    const url = `${this.baseUrl}/get-tariffe-energy`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async createTariffa(value){
    const url = `${this.baseUrl}/create-tariffa-energy`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async editTariffe(value){
    const url = `${this.baseUrl}/edit-tariffe-energy`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteTariffa(value){

    const url = `${this.baseUrl}/delete-tariffa-energy`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteTariffe(value){

    const url = `${this.baseUrl}/delete-tariffe-energy`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async getAllTariffeGas(){
    let items = {}
    const url = `${this.baseUrl}/get-tariffe-gas`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async createTariffaGas(value){
    const url = `${this.baseUrl}/create-tariffa-gas`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async editTariffeGas(value){
    const url = `${this.baseUrl}/edit-tariffe-gas`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteTariffaGas(value){

    const url = `${this.baseUrl}/delete-tariffa-gas`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteTariffeGas(value){

    const url = `${this.baseUrl}/delete-tariffe-gas`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  
  async getEstrattiConto(dateFrom = undefined, dateTo = undefined, used = 0){
    let items = {}
    const url = `${this.baseUrl}/get-estratti-conto/${dateFrom}/${dateTo}/${used}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getTypesPay(){
    let items = {}
    const url = `${this.baseUrl}/get-types-pay`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getTypesPayMode(){
    let items = {}
    const url = `${this.baseUrl}/get-types-pay-mode`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async editEstrattoConto(value){
    const url = `${this.baseUrl}/estratti-conto/edit`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async saveMovimento(dateContabile, dateValuta, valueMovement, descriptionMovement, cod_type_pay_mode, type_pay){
 
    const url = `${this.baseUrl}/save-movement`

    try {
        let res = await axios.post(url, {
          data: {
            dateContabile,
            dateValuta,
            valueMovement,
            descriptionMovement,
            cod_type_pay_mode,
            type_pay
          }
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteEstrattiConto(value){
    
    const url = `${this.baseUrl}/delete-estratti-conto`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async regMassiva(value, type_pay_mode){
    
    const url = `${this.baseUrl}/regolarizzazione-massiva`

    try {
        let res = await axios.post(url, {
          value, 
          type_pay_mode
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async uploadFile(fileFormData){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/upload-file-estratti-conto`

    try {
        let res = await axios.post(url, fileFormData,  settings)
        //this.eventBus.emit('data-load-success', {message: res.data})
        items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
         // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }      
    }

  }

  async saveMovimenti(array){
    
    const url = `${this.baseUrl}/save-movements`

    try {
        let res = await axios.post(url, {
          data: array
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async getMassiveTypes(){
    let items = []
    const url = `${this.baseUrl}/get-massive-types`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getProviders(){
    let items = []
    const url = `${this.baseUrl}/get-providers`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getMassiveRequest(){
    let items = {}
    const url = `${this.baseUrl}/get-massive-request`
    // const url = 'http://processi.askmanagement.it/api/pratiche/v1/get-massive-request'

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getMassiveRequestSearch(fornitura, type, period){
    let items = {}
    const url = `${this.baseUrl}/get-massive-request-search`
    
    try {
      let res = await axios.post(url, { 
        fornitura, 
        type,
        period  
      })
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getPodId(podCode){
    let item = ''
    const url = `${this.baseUrl}/get-pod-id/${podCode}`

    try {
        let res = await axios.get(url)
        item = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            item,
        }
    }

  }


  async getPreviews(){
    let items = {}
    const url = `${this.baseUrl}/get-preview/month/summary`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getPreviewDetails(date, stima){
    let items = {}
    const url = `${this.baseUrl}/get-preview/month/details/${date}/${stima}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getEstrattoConto(id){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/${id}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async splitMovements(id, import1, import2, descrizione, type_pay, type_pay_mode, data_contabile, data_valuta ){

    let itemId = null
    const url = `${this.baseUrl}/estratto-conto/detail/split-movements`
    
    try {
      let res = await axios.post(url, {  
        id, import1, import2, descrizione, type_pay, type_pay_mode, data_contabile, data_valuta  
      })
      itemId = res.data.newId
      this.eventBus.emit('data-load-success', {message: res.data.message})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
          itemId,
      }
    }

  }



  async getSuggerimenti(resource, search){
    let items = {}
    const url = `${this.baseUrl}/suggerimenti/${resource}/details?&filters[search]=${search}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getRappresentanti(){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/rappresentanti`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getRappresentanteSaldo(id){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/rappresentante/saldo/${id}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }


  async getFattureDaSaldareRapp(idRapp){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/rappresentante/fatture-da-saldare/${idRapp}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async associateToPayments(obj){
    
    const url = `${this.baseUrl}/estratto-conto/detail/associate-to-payments`

    try {
        let res = await axios.post(url, {
          data: obj
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async associateNoteToPayments(obj){
    
    const url = `${this.baseUrl}/estratto-conto/detail/associate-note-to-payments`

    try {
        let res = await axios.post(url, {
          data: obj
        })
        if (res.data.response) {
          this.eventBus.emit('data-load-success', {message: res.data.message})
        }
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async dissociateToPayments(estrattoConto, fatture, fornitori){
    
    const url = `${this.baseUrl}/estratto-conto/detail/dissociate-to-payments`

    try {
        let res = await axios.post(url, {
          estrattoConto, fatture, fornitori
        })
        if (res.data.response) {
          this.eventBus.emit('data-load-success', {message: res.data.message})
        } 
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async substituteNumberInvoice(newNumero, oldPayment){
    
    const url = `${this.baseUrl}/estratto-conto/detail/substitute-payment`

    try {
        let res = await axios.post(url, {
          data: {newNumero, oldPayment}
        })

        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  
  async getPrevNextDetail(idEstrattoConto){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/prev-next/${idEstrattoConto}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getClienti(){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/clienti`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getFattureDaSaldareClient(idClient){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/cliente/fatture-da-saldare/${idClient}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getFornitori(){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/fornitori`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFattureDaSaldareFornitore(idFornitore){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/fornitore/fatture-da-saldare/${idFornitore}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getTypesPayModeGiroconto(cod_type_pay_mode){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/get-types-pay-mode/${cod_type_pay_mode}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async associateToConto(idEstrattoConto, idTypePayMode){

    const url = `${this.baseUrl}/estratto-conto/detail/associate-to-conto`

    try {
        let res = await axios.post(url, {
          data: {
            'idEstrattoConto' : idEstrattoConto,
            'idTypePayMode' : idTypePayMode
          }
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async associateToCommercialista(estrattoConto, nota){

    const url = `${this.baseUrl}/estratto-conto/detail/associate-to-commercialista`

    try {
        let res = await axios.post(url, {
          estrattoConto,
          nota
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  
  async getPaymentsAssociated(idEstrattoConto){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/get-payments-associated/${idEstrattoConto}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getNoteDetail(idFattura, typeNote){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/note/${typeNote}/${idFattura}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getRids(estrattoConto, period){
    if (period) {
      estrattoConto.period = period
    }

    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/get-rids`

    try {
        let res = await axios.post(url, {
          estrattoConto
        })
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


async getCombinationsRid(estrattoConto, period){

  if (period) {
    estrattoConto.period = period
  }

  let items = {}
  const url = `${this.baseUrl}/estratto-conto/detail/get-combinations-rid`

  try {
      let res = await axios.post(url, {
          estrattoConto
      })
      items = res.data
  } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
  } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
          items,
      }
  }

}

  
  

  
  async associateToRids(obj){
  
      const url = `${this.baseUrl}/estratto-conto/detail/associate-to-rids`

      try {
          let res = await axios.post(url, {
              data: obj
          })
          this.eventBus.emit('data-load-success', {message: res.data.message})
          return res.data.response
      } catch (err) {
          this.eventBus.emit('data-load-error', {message: err, url})
      } finally {
          this.eventBus.emit('data-loaded')      
      }

  }


  async getBonusSociale(){
    let items = {}
    const url = `${this.baseUrl}/get-bonus-sociale`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getCheckRecessi(type, date, file){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/check/recessi`
    let fd = new FormData();
    fd.append('type', type);
    fd.append('date', date);
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      let res = await axios.post(url, fd , settings)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getControlloConsumi(type, used, period, percentage){
    let items = {}
    const url = `${this.baseUrl}/get-controllo-consumi`

    try {
      let res = await axios.post(url, {
          data: {
            'type': type,
            'used': used,
            'period': period,
            'percentage': percentage
          }
      })
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getReportPod(date){
    let items = {}
    const url = `${this.baseUrl}/get-report-pod/${date}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getControlloRid(from, to){
    let items = {}
    const url = `${this.baseUrl}/get-controllo-rid/${from}/${to}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFornitoriControlloFatture(){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/get-fornitori`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFornitoriControlloFattureHasDetailsEe(){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/ee/get-fornitori-has-details`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFornitoriControlloFattureHasDetailsGas(){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/gas/get-fornitori-has-details`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getConsumptionsControlloFattureFornitoriEe(dateStart, dateEnd, fornitoreId){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/ee/get-consumption`

    try {
        let res = await axios.post(url, {dateStart, dateEnd, fornitoreId})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getConsumptionsControlloFattureFornitoriGas(dateStart, dateEnd, fornitoreId){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/gas/get-consumption`

    try {
        let res = await axios.post(url, {dateStart, dateEnd, fornitoreId})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getControlloAcquistatoVendutoFornitori(date, tipo, tipoFornitura){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/acquistato-venduto/${date}/${tipo}/${tipoFornitura}`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getQuantitaMateriaFornitoriDogane(dataEmissione, fornitori){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/quantita/fornitori/dogane`

    try {
        let res = await axios.post(url, {dataEmissione, fornitori})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getBanksTypeRid(){
    let items = {}
    const url = `${this.baseUrl}/banks/type-rid`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getSummaryRidsMonth(cod_type_pay_mode, type_sdd, type_date, year){
    let items = {}
    const url = `${this.baseUrl}/rid/riepilogo/mensile`

    try {
        let res = await axios.post(url, {cod_type_pay_mode, type_sdd, type_date, year})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getSummaryInsoluti(obj, year, hasDetails){
    let items = {}
    const url = `${this.baseUrl}/insoluti/riepilogo/mensile`

    try {
        let res = await axios.post(url, {obj, year, hasDetails})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }
  async sendPdfSummaryInsoluti(obj, year, hasDetails){
    let items = {}
    const url = `${this.baseUrl}/insoluti/riepilogo/mensile/send-pdf`

    try {
      let res = await axios({
        url,
        method: 'POST',
        data: {obj, year, hasDetails},
      })
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getSummaryPayments(dates, excludeRidAndCompensation, excludeOut){
    let items = {}
    const url = `${this.baseUrl}/payments/riepilogo`

    try {
        let res = await axios.post(url, {dates,excludeRidAndCompensation, excludeOut})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async sendSummaryPayments(data){
    let item = {}
    const url = `${this.baseUrl}/payments/riepilogo/email`

    try {
        let res = await axios.post(url, {data})
        item = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            item,
        }
    }

  }


  async getProfiles(){
    let items = {}
    const url = `${this.baseUrl}/profiles`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }
  
  async getUsersWithProfiles(){
    let items = {}
    const url = `${this.baseUrl}/profile/users`  

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async editUserProfile(value){
    const url = `${this.baseUrl}/profile/user/edit`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteUser(value){
    const url = `${this.baseUrl}/profile/user/delete`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async createUser(value){
    let item = {}
    const url = `${this.baseUrl}/profile/user/create`

    try {
        let res = await axios.post(url, {
          data: value
        })
        item = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          item,
        }    
    }

  }

  async editFatturaVoci(value){
    const url = `${this.baseUrl}/fattura/voci/edit`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteFatturaVoci(value){
    const url = `${this.baseUrl}/fattura/voci/delete`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async createFatturaVoce(value){
    const url = `${this.baseUrl}/fattura/voci/create`

    try {
        let res = await axios.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async getPrevisionalDispacciamento(file, data_decorrenza){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/previsionale/dispacciamento`
    let fd = new FormData();
    fd.append('data_decorrenza', data_decorrenza);
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      let res = await axios.post(url, fd , settings)

      items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }
    }

  }


  async uploadFilePratiche(file, provider){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/pratiche/upload/file`
    let fd = new FormData();
    fd.append('provider', JSON.stringify(provider));
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      let res = await axios.post(url, fd , settings)
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }
    }
  }

  async updatePratica(code){
    const url = `${this.baseUrl}/pratiche/update/massive/request/${code}`

    try {
      let res = await axios.get(url)
      this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async getPreviewSospensioniRiattivazioni(typeFornitura, typePratica){
    let items = {}
    const url = `${this.baseUrl}/preview/sospensioni-riattivazioni`  

    try {
        let res = await axios.post(url, {typeFornitura, typePratica})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getSospensioniRiattivazioniForniture(typeFornitura, typePratica, dateFrom, dateTo){
    let items = {}
    const url = `${this.baseUrl}/forniture/sospensioni-riattivazioni`  

    try {
        let res = await axios.post(url, {typeFornitura, typePratica, dateFrom, dateTo})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async downloadFileSospRiattPratiche(items){

    const url = `${this.baseUrl}/forniture/sospensioni-riattivazioni/download`
    try {
        let res = 
        await axios({
            url,
            method: 'POST',
            data: {items},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  async getFornitureInCmor(typeFornitura, date, saldo){
    let items = {}
    const url = `${this.baseUrl}/forniture/cmor`

    try {
        let res = await axios.post(url, {typeFornitura, date, saldo })
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async generateAndSendFileCmor(objs){
    let items = {}
    const url = `${this.baseUrl}/forniture/cmor/generate/template`

    try {
        let res = await axios.post(url, {objs})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }



  
  async getPrevisionaleIncassi(){
    let items = {}
    const url = `${this.baseUrl}/previsionale/incassi`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getInvoicesWithCmor(dates){
    let items = {}
    const url = `${this.baseUrl}/fatture/cmor`

    try {
        let res = await axios.post(url, {dates})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async updateDataInvioToCmorSent(obj){
    let items = {}
    const url = `${this.baseUrl}/fatture/cmor/update/data_invio`

    try {
        let res = await axios.post(url, {obj})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async addPrevisionalDates(dates){
    let items = {}
    const url = `${this.baseUrl}/previsionale/incassi/add/dates`

    try {
        let res = await axios.post(url, {dates})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getDetailsPrevisionalIncassiUscite(date){
    let items = {}
    const url = `${this.baseUrl}/previsionale/incassi/uscite/details`

    try {
        let res = await axios.post(url, {date})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getCostiPratiche(date){
    let items = {}
    const url = `${this.baseUrl}/get-costi-pratiche`

    try {
        let res = await axios.post(url, {date})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async addCostiPratiche(objs){
    let items = {}
    const url = `${this.baseUrl}/add-costi-pratiche`

    try {
        let res = await axios.post(url, {objs})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getContabili(){
    let items = {}
    const url = `${this.baseUrl}/contabili/all`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async verifyNewContabile(contabile){
    let items = []
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/contabile/verify`
    let fd = new FormData();
    fd.append('contabile', JSON.stringify(contabile));
    for (let i = 0 ; i < contabile.fileToUpload.length ; i++) {
      fd.append('files[]', contabile.fileToUpload[i]); 
    }
    

    try {
      let res = await axios.post(url, fd , settings)
      items = res.data
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }

  }


  async importNewContabile(contabile){
    // let items = [] 
    const url = `${this.baseUrl}/contabile/import`

    try {
        let res = await axios.post(url, {contabile})
        return res.data
        
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async downloadContabileFile(path){

    const url = `${this.baseUrl}/contabile/file/download`
    try {
        let res = 
        await axios({
            url,
            method: 'POST',
            data: {path},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})
        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async deleteContabile(id){
    let items = {}
    const url = `${this.baseUrl}/contabile/${id}/delete`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getAnalisiFornitori(type, dateFrom, dateTo){
    let items = {}
    const url = `${this.baseUrl}/controllo/analisi-fornitori`

    try {
        let res = await axios.post(url, {type, dateFrom, dateTo})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async checkInvoicesFromDescription(arr){

    let items = {}
    const url = `${this.baseUrl}/estratti-conto/check-invoices-from-description`

    try {
        let res = await axios.post(url, { data:arr})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async associateAutoToPayments(objs){
    
    const url = `${this.baseUrl}/estratto-conto/detail/associate-auto-to-payments`

    try {
        let res = await axios.post(url, {
          data: objs
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  
  async foundCombinationsBollettini(objs){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/found/combinations/bollettini`

    try {
        let res = await axios.post(url, {
          data: objs
        })
        // this.eventBus.emit('data-load-success', {message: res.data.message})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }

  async associateBollettini(objs){

    const url = `${this.baseUrl}/estratto-conto/associate/bollettini`

    try {
        let res = await axios.post(url, {
          data: objs
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async importRicalcoli(file){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/estratti-conto/import/ricalcoli`
    let fd = new FormData();
    fd.append('file', file); 

    try {
      let res = await axios.post(url, fd,  settings)
      items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
         // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }      
    }

  }


  async importGiroconti(file){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/estratti-conto/import/giroconti`
    let fd = new FormData();
    fd.append('file', file); 

    try {
      let res = await axios.post(url, fd,  settings)
      items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
         // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }      
    }

  }



  async exportPdfInsoluti(items, removePaid){

    const url = `${this.baseUrl}/insoluti/riepilogo/mensile/pdf/download`
    try {
        let res = 
        await axios({
            url,
            method: 'POST',
            data: {items, removePaid},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  async exportCsvInsoluti(items, removePaid){

    const url = `${this.baseUrl}/insoluti/riepilogo/mensile/csv/download`
    try {
        let res = 
        await axios({
            url,
            method: 'POST',
            data: {items, removePaid},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }
  
  
  async getPdpReadyToSwitch(typeFornitura, typeTensione, typeProduzione, udds, distributors, typesOfferta, data_decorrenza){
    let response = {}
    const url = `${this.baseUrl}/switch-in/ready/to-switch`

    try {
        let res = await axios.post(url, {typeFornitura, typeTensione, typeProduzione, udds, distributors, typesOfferta, data_decorrenza})
        // this.eventBus.emit('data-load-success', {message: res.data.message})
        response = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            response,
        } 
    }

  }


  async getPdpSwitchCaricati(typeFornitura,data_decorrenza,tipoSwitch){
    let items = {}
    const url = `${this.baseUrl}/switch-in/uploaded`

    try {
        let res = await axios.post(url, {typeFornitura, data_decorrenza, tipoSwitch})
        // this.eventBus.emit('data-load-success', {message: res.data.message})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }

  async getPdpSwitchCaricatiCache(typeFornitura,data_decorrenza,tipoSwitch){
    const url = `${this.baseUrl}/switch-in/uploaded/cache`;

    try {
      return await axios.post(url, {typeFornitura, data_decorrenza, tipoSwitch})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }
  }

  async deleteSwithInByDataDecorrenza(data_decorrenza) {
    const url = `${this.baseUrl}/switch-in/delete/data-decorrenza?data_decorrenza=${data_decorrenza}`;

    try {
      let res = await axios.get(url);
      return res;
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    }
  }



  async downloadTemplateSwitchInProviders(providers, typeFornitura, total_kwh_available){

    const url = `${this.baseUrl}/switch-in/providers/template/download`
    try {
        let res = 
        await axios({
            url,
            method: 'POST',
            data: {providers, typeFornitura, total_kwh_available},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async getUddsForSwitchin(typeFornitura){
    let items = {}
    const url = `${this.baseUrl}/switch-in/udds/${typeFornitura}/to-switch`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }


  async getAccettazioniCronProgress(){
    const url = `${this.baseUrl}/switch-in/accettazioni/progress`

    try {
      return await axios.get(url)
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async uploadFileSwitchOk(file, typeFornitura){
    let res
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/switch-in/${typeFornitura}/change/status`
    let fd = new FormData();
    fd.append('typeFornitura', typeFornitura); 
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      res = await axios.post(url, fd , settings)
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          res
        }
    }
  }

  async uploadFileTIMOETIMG(file, typeFornitura){
    let item = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/switch-in/${typeFornitura}/change/status`
    let fd = new FormData();
    fd.append('typeFornitura', typeFornitura); 
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      let res = await axios.post(url, fd , settings)
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
      item = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          item,
        }
    }
  }


  async getDistributorsForSwitchin(typeFornitura){
    let items = {}
    const url = `${this.baseUrl}/switch-in/distributors/${typeFornitura}/to-switch`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }


  async getTemplatesAvailable(){
    let items = {}
    const url = `${this.baseUrl}/switch-in/templates/available`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }


  
  async generateTemplateSwitchinFromFile(file, typeFornitura, provider){
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/switch-in/generate/template/from-file`
    let fd = new FormData();
    fd.append('typeFornitura', typeFornitura); 
    fd.append('provider', JSON.stringify(provider)); 
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      // let res = await axios.post(url, fd , settings)
      let res = 
        await axios({
            url,
            method: 'POST',
            data: fd,
            responseType: 'blob',
            ...settings
          })

        this.filemanager.download(res)
      
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
    }
  }

  async importSwitch(file, typeFornitura, provider){
    let res
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/switch-in/declare`
    let fd = new FormData();
    fd.append('typeFornitura', typeFornitura); 
    fd.append('provider', JSON.stringify(provider)); 
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      res = await axios({
        url,
        method: 'POST',
        data: fd,
        ...settings
      })      
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          res
        }
    }
  }


  async getSummaryProvvigioni(agentId, years, typeView, typeGroup){
    let items = []
    const url = `${this.baseUrl}/provvigioni/riepilogo`

    try {
      let res =  await axios.post(url, {agentId, years, typeView, typeGroup})
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getInternalPurchasePrice(){
    let items = {}
    const url = `${this.baseUrl}/prezzo-acquisto`

    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }
  }


  async saveInternalPurchasePrice(item){
    let success = {}
    const url = `${this.baseUrl}/prezzo-acquisto/save`

    try {
      let res =  await axios.post(url, {item})
      success = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
          success,
        }
    }

  }


  async getSwitchOutCheck(typeFornitura, dataDecorrenza, dataPratica){
    let items = {}
    // const url = `${this.baseUrl}/switch-out/check`
    const url = `${this.praticheBase}/api/switch-management/display/switchout`

    try {
        let res = await axios.post(url, {typeFornitura, dataDecorrenza, dataPratica})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }
  async setContrattiMensili(fd){
    let items = {}
    const url = `${this.baseUrl}/change-contratti-mensili`

    try {
        let res = await axios.post(url, fd)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }


  async exportSwoutGroup(objs){

    const url = `${this.baseUrl}/switch-out/agents/group/download`
    try {
        let res = 
        await axios({
            url,
            method: 'POST',
            data: {objs},
            responseType: 'blob',
          })

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  
  async getStorniRidPayments(dates){
    let items = {}
    const url = `${this.apiUrl}/clienti/fatture/storni/rid`

    try {
        let res = await axios.post(url, {dates})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }




  async updateMotivazioni(motivazioniData) {
    const url = `${this.apiUrl}/clienti/fatture/storni/rid/motivazioni`;
  
    try {
      console.log("Dati inviati al backend:", motivazioniData);
  
      const res = await axios.post(url, { motivazioni: motivazioniData });
  
      if (res.status === 200) {
        this.eventBus.emit('motivazioni-update-success', {
          message: 'Motivazioni aggiornate con successo'
        });
      }
    } catch (err) {
      this.eventBus.emit('motivazioni-update-error', {
        message: 'Errore durante l\'aggiornamento delle motivazioni',
        error: err
      });
    } finally {
      this.eventBus.emit('motivazioni-update-complete');
    }
  }



  async sendEmailToAgents(agentData) {
    const url = `${this.apiUrl}/clienti/fatture/storni/rid/invio/agenti`;
  
    try {
      const res = await axios.post(url, {
        agentData: agentData
      });
  
      if (res.status === 200) {
        this.eventBus.emit('email-agenti-success', {
          message: 'Email inviate con successo',
        });
      }
    } catch (err) {
      this.eventBus.emit('email-agenti-error', {
        message: "Errore durante l'invio delle email agli agenti",
        error: err,
      });
    } finally {
      this.eventBus.emit('email-agenti-complete');
    }
  }

  async generatePDFStorniRid(agentName, data) {
    const url = `${this.apiUrl}/clienti/fatture/storni/rid/generate-pdf-storni`; 
    try {
      const response = await axios.post(
        url,
        { agentName, data },
        {
          responseType: 'blob', 
        }
      );
      return response;
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  }




  async sendEmailStorniRidPayments(objs){
    let items = {}
    const url = `${this.apiUrl}/clienti/fatture/storni/rid/invio`

    try {
        let res = await axios.post(url, {objs})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }

  async downloadCsvProvvigioni(agentId, month){
    const url = `${this.baseUrl}/provvigioni/riepilogo/export`

    try {
      let res = await axios({
          url,
          method: 'POST',
          data: {agentId, month},
          responseType: 'blob',
        })
      //this.eventBus.emit('data-load-success', {message: res.data})
      this.filemanager.download(res)
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }
  }

  async getPrevisionalUsciteFuture(dates = null) {
    let items = {}
    const url = `${this.baseUrl}/previsionale/uscite/future`
    const config = dates ? { params: { dates } } : {}

    try {
        let res = await axios.get(url, config)
        items = res.data
        return {
            items,
        }
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return {
            items,
        }
    } finally {
        this.eventBus.emit('data-loaded')      
    }
  }

  async getScadenzaFatturePerGrafico() {
    let items = []
    const url = `${this.baseUrl}/previsionale/scadenza/fatture/grafico`
  
    try {
      let res = await axios.get(url)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }
  
  async getDettaglioUsciteSettimanali(weekIndex) {
    let items = []
    const url = `${this.baseUrl}/previsionale/scadenza/fatture/dettaglio-uscite/${weekIndex}`
  
    try {
      let res = await axios.post(url)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }
  
  async getDettaglioIncassiSettimanali(weekIndex) {
    let items = []
    const url = `${this.baseUrl}/previsionale/scadenza/fatture/dettaglio-incassi/${weekIndex}`
  
    try {
      let res = await axios.post(url)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }

  async getPrevisionaleSwitchout() {

    let items = {};
    const url = `${this.baseUrl}/previsionale/fornitura`;

    try {
      let result = await axios.get(url);
      items = result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return items;
  }

  async getPodDetailsPrevisionaleSwitchout(page) {

    let items = {};
    const url = `${this.baseUrl}/previsionale/fornitura/details/pod?page=${page}`;

    try {
      let result = await axios.get(url);
      items = result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return items;
  }

  async getPdrDetailsPrevisionaleSwitchout(page) {

    let items = {};
    const url = `${this.baseUrl}/previsionale/fornitura/details/pdr?page=${page}`;

    try {
      let result = await axios.get(url);
      items = result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return items;
  }

  async getInfoFromPraticheDossier() {
    let items = {}
    const url = `${this.baseUrl}/pratiche/dossier/info`
    
    try {
      let res = await axios.post(url)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }

  async getInfoCodiciConto(params) {
    let items = {}
    const url = `${this.baseUrl}/get-info-codici-conto`
  
    try {
      let res = await axios.post(url, params)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }

  async getDataForEmailOrFrontendSwoutCredito(tipoFornitura, date) {
    let items = {}
    const url = `${this.praticheBase}/api/switch-management/display/switchout/credito`

    try {
        let res = await axios.post(url, {tipoFornitura, date})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }
  }
}


